(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4],{

/***/ 40004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_detalles_dos_src; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 38 modules
var esm = __webpack_require__(52257);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var src = __webpack_require__(145);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ../packages/ab-detalles-dos/src/EscapadaDetail.tsx



var EscapadaDetail = function(param) {
    var itm = param.itm, isOpen = param.isOpen;
    var ref = (0,react.useState)(isOpen), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "escapada-detail ".concat(open ? "" : "closed"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "h3",
                                children: itm.nombre
                            }),
                            itm.subtitulo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "span",
                                className: "title",
                                children: itm.subtitulo
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        width: "41",
                        height: "41",
                        viewBox: "0 0 41 41",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        onClick: function() {
                            return setOpen(!open);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                cx: "20.334",
                                cy: "20.5",
                                r: "20",
                                transform: "rotate(90 20.334 20.5)",
                                fill: "#E3DECF"
                            }),
                            open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M25.3536 22.1869C25.176 22.3644 24.8983 22.3806 24.7025 22.2353L24.6464 22.1869L20.3333 17.874L16.0202 22.1869C15.8427 22.3644 15.5649 22.3806 15.3692 22.2353L15.3131 22.1869C15.1356 22.0094 15.1195 21.7316 15.2647 21.5359L15.3131 21.4798L19.9798 16.8132C20.1573 16.6356 20.4351 16.6195 20.6308 16.7647L20.6869 16.8132L25.3536 21.4798C25.5488 21.6751 25.5488 21.9917 25.3536 22.1869Z",
                                fill: "#A79669"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M14.9804 18.3131C15.1579 18.1356 15.4357 18.1195 15.6315 18.2647L15.6875 18.3131L20.0007 22.626L24.3138 18.3131C24.4913 18.1356 24.7691 18.1195 24.9648 18.2647L25.0209 18.3131C25.1984 18.4906 25.2145 18.7684 25.0693 18.9642L25.0209 19.0202L20.3542 23.6869C20.1767 23.8644 19.8989 23.8806 19.7032 23.7353L19.6471 23.6869L14.9804 19.0202C14.7852 18.825 14.7852 18.5084 14.9804 18.3131Z",
                                fill: "#A79669"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                children: itm.descripcion
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: itm.incluye.map(function(itm) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        children: itm === null || itm === void 0 ? void 0 : itm.texto
                    });
                })
            }),
            itm.precio ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                element: "span",
                className: "title",
                children: itm.precio
            }) : null
        ]
    });
};
/* harmony default export */ var src_EscapadaDetail = (EscapadaDetail);

// EXTERNAL MODULE: ../packages/ab-detalles-dos/src/ab-detalles-dos.scss
var ab_detalles_dos = __webpack_require__(89845);
;// CONCATENATED MODULE: ../packages/ab-detalles-dos/src/index.tsx





var DetallesDos = function(param) {
    var detalles = param.detalles, _color = param.color, color = _color === void 0 ? "" : _color, i18n = param.i18n;
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-detalles-dos ".concat(color),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                    element: "h2",
                    children: t("queIncluye")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "right",
                children: detalles === null || detalles === void 0 ? void 0 : detalles.map(function(itm, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_EscapadaDetail, {
                        itm: itm,
                        isOpen: index == 0
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var ab_detalles_dos_src = (DetallesDos);


/***/ }),

/***/ 89845:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);